module.exports = __webpack_public_path__ + "static/media/ceris.608d18f2.PNG";